import { Box, Card, CardContent, CardMedia, Chip, Typography } from '@mui/material';

import type { DrawnEntry } from '@/types/reading';

import {
  revealedCardBodyTextSx,
  revealedCardChipSx,
  revealedCardImageSx,
  revealedCardImageWrapperSx,
  revealedCardInfoBoxSx,
  revealedCardOrientationLabelSx,
  revealedCardPositionSx,
  revealedCardRootSx,
  revealedCardTitleSx,
} from './RevealedCard.styles';

interface Props {
  entry: DrawnEntry;
}

function RevealedCard({ entry }: Props) {
  const { card, isReversed, position } = entry;
  const meaning = isReversed ? card.reversed : card.upright;
  const orientationLabel = isReversed ? 'Reversed' : 'Upright';
  const arcanaChipLabel = card.arcana === 'major' ? `Major Arcana · ${card.roman}` : card.suit;

  return (
    <Card sx={revealedCardRootSx}>
      <Box sx={revealedCardImageWrapperSx}>
        <CardMedia
          component="img"
          image={card.image}
          alt={card.name}
          sx={revealedCardImageSx(isReversed)}
        />
      </Box>
      <CardContent>
        <Typography variant="overline" color="primary" sx={revealedCardPositionSx}>
          Position: {position}
        </Typography>
        <Typography variant="h6" sx={revealedCardTitleSx}>
          {card.name}
        </Typography>
        <Chip label={arcanaChipLabel} size="small" variant="outlined" sx={revealedCardChipSx} />
        {isReversed && (
          <Chip label="Reversed" size="small" color="warning" sx={revealedCardChipSx} />
        )}
        <Box sx={revealedCardInfoBoxSx}>
          <Typography variant="body2" color="secondary" sx={revealedCardOrientationLabelSx}>
            <strong>{orientationLabel}:</strong>
          </Typography>
          <Typography variant="body2" sx={revealedCardBodyTextSx}>
            {meaning}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            <strong>Keywords:</strong> {card.keywords.join(', ')}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default RevealedCard;
